// Fiscal settings → register the cash register (ENU/TCR) with the Tax Administration.
import React, { useEffect, useState } from 'react';
import { Cpu, Loader2 } from 'lucide-react';
import { apiCall } from './_shared';

const TcrRegisterPanel = ({ canManage, onRegistered }) => {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ tcr_int_id: '1', valid_from: new Date().toISOString().slice(0, 10), tcr_type: 'REGULAR' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const load = () => apiCall('/api/admin/fiscal/tcr').then(setData).catch(() => {});
  useEffect(() => { load(); }, []);

  const register = async () => {
    if (!window.confirm(`Register cash register #${form.tcr_int_id} (${form.tcr_type}) valid from ${form.valid_from} with the Tax Administration? The returned TCR code will replace the current one.`)) return;
    setBusy(true); setMsg('');
    try {
      const r = await apiCall('/api/admin/fiscal/tcr/register', { method: 'POST', body: JSON.stringify(form) });
      setMsg(`Registered · TCR code ${r.tcr_code}`); await load(); onRegistered && onRegistered(r.tcr_code);
    } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };

  const reg = data?.registration;
  const history = (data?.history || []).slice(0, 5).map((h) => (
    <div key={h.id} className="flex flex-wrap gap-2 text-[11px] text-slate-500" data-testid={`tcr-history-${h.id}`}>
      <span>{String(h.at).slice(0, 16).replace('T', ' ')}</span><span>#{h.tcr_int_id} · {h.tcr_type} · {h.env}</span>
      {h.status === 'ok' ? <span className="text-emerald-700 font-mono">{h.tcr_code}</span> : <span className="text-red-600" title={h.error}>failed · {String(h.error || '').slice(0, 60)}</span>}
    </div>
  ));

  return (
    <div className="rounded-lg border border-dashed p-3 space-y-2" data-testid="tcr-panel">
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="font-semibold text-slate-800 inline-flex items-center gap-1"><Cpu className="w-3.5 h-3.5" /> Cash register (ENU / TCR) registration</span>
        {reg?.tcr_code ? <span className="text-emerald-700" data-testid="tcr-registered">Registered {String(reg.at).slice(0, 10)} · <span className="font-mono">{reg.tcr_code}</span> · {reg.env}</span>
          : <span className="text-slate-500" data-testid="tcr-unregistered">Not registered from this app yet — enter an existing TCR code above or register one here.</span>}
      </div>
      {canManage && (
        <div className="flex flex-wrap items-end gap-2 text-xs text-slate-600">
          <label>Internal ID<input value={form.tcr_int_id} onChange={(e) => setForm({ ...form, tcr_int_id: e.target.value })} className="mt-0.5 w-20 border rounded px-2 py-1 text-sm font-mono" data-testid="tcr-int-id" /></label>
          <label>Valid from<input type="date" value={form.valid_from} onChange={(e) => setForm({ ...form, valid_from: e.target.value })} className="mt-0.5 border rounded px-2 py-1 text-sm" data-testid="tcr-valid-from" /></label>
          <label>Type<select value={form.tcr_type} onChange={(e) => setForm({ ...form, tcr_type: e.target.value })} className="mt-0.5 border rounded px-2 py-1 text-sm" data-testid="tcr-type"><option value="REGULAR">REGULAR</option><option value="VENDING">VENDING</option></select></label>
          <button type="button" onClick={register} disabled={busy} className="inline-flex items-center gap-1 bg-emerald-600 text-white rounded-lg px-3 py-1.5 text-sm font-semibold disabled:opacity-60" data-testid="tcr-register">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Cpu className="w-4 h-4" />} Register TCR
          </button>
          {msg && <span className="font-semibold text-slate-800" data-testid="tcr-msg">{msg}</span>}
        </div>
      )}
      {history.length > 0 && <div className="space-y-0.5" data-testid="tcr-history">{history}</div>}
    </div>
  );
};

export default TcrRegisterPanel;
